// extracted by mini-css-extract-plugin
module.exports = {"h1paadp4":"h1paadp4","hiir0tf":"hiir0tf"};